import React, { useRef } from 'react';
import { TabsBase } from './TabsBase';
import { useTabs } from './useTabs';
import { TabsContext } from './Context';
export const Tabs = ({ initialSelectedTab, disableContainer = false, disableDropdownSmDown, tabs, onSelectedTabChange, accessibleDropdownTitle, }) => {
    const panelContentRef = useRef(null);
    const { selectedTab, onSelectedTabChange: onSelectedTabChangeInternal, activeTab, setActiveTab, dropdownOpen, setDropdownOpen, } = useTabs({ initialSelectedTab, panelContentRef });
    const handleSelectedTabChange = (index, focusPanelContent) => {
        onSelectedTabChangeInternal(index, focusPanelContent);
        // Pass up the value if parent needs it
        if (onSelectedTabChange) {
            onSelectedTabChange(index);
        }
    };
    const conditionalProps = !disableDropdownSmDown
        ? {
            disableDropdownSmDown: false,
            dropdownOpen,
            dropdownPlacement: 'bottom-start',
            accessibleDropdownTitle,
            handleDropdownOpenChange: setDropdownOpen,
        }
        : { disableDropdownSmDown: true };
    return (React.createElement(TabsContext.Provider, { value: { selectedTab } },
        React.createElement(TabsBase, Object.assign({ selectedTab: selectedTab, onSelectedTabChange: handleSelectedTabChange, activeTab: activeTab, onActiveTabChange: setActiveTab, disableContainer: disableContainer, tabs: tabs, panelContentRef: panelContentRef }, conditionalProps))));
};
//# sourceMappingURL=Tabs.js.map